export default {
  "content": "<circle cx=\"18\" cy=\"18\" r=\"18\" fill=\"#FFD600\"/><path d=\"M23.538 22.947c.692 1.124 1.444 2.201 3.037 2.201 1.338 0 2.04-.665 2.04-1.585 0-1.101-.726-1.492-2.198-2.133l-.807-.344c-2.329-.988-3.878-2.226-3.878-4.841 0-2.41 1.845-4.244 4.728-4.244 2.053 0 3.528.711 4.592 2.573l-2.514 1.607c-.553-.988-1.151-1.377-2.078-1.377-.946 0-1.545.597-1.545 1.377 0 .964.6 1.354 1.985 1.951l.807.344C30.452 19.645 32 20.839 32 23.523 32 26.415 29.716 28 26.65 28c-2.999 0-4.702-1.505-5.65-3.368l2.538-1.685zm-11.586.082c.506.906 1.275 1.603 2.381 1.603 1.058 0 1.667-.418 1.667-2.043V12h3.333v11.101c0 3.367-1.953 4.899-4.805 4.899-2.577 0-4.437-1.746-5.195-3.368l2.619-1.603z\" fill=\"#000001\"/>",
  "attrs": {
    "width": "36",
    "height": "36",
    "viewBox": "0 0 36 36",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};